module.exports = __webpack_public_path__ + "img/IT0000104420510.b0b9e72a.png";